<script setup>
import { computed, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthStore } from '@/stores/auth'
import { startRealtime, stopRealtime } from '@/lib/realtime'
import { Toaster } from 'vue-sonner'
import AppSidebar from '@/components/AppSidebar.vue'

const route = useRoute()
const auth = useAuthStore()

// Telas "bare" (ex.: login) não usam o shell com sidebar.
const bare = computed(() => route.meta.layout === 'bare')
const fullPage = computed(() => route.matched.some(record => record.name === 'chamado'))

// Realtime (ActionCable): liga ao autenticar, desliga no logout.
watch(
  () => auth.isAuthenticated,
  authed => (authed ? startRealtime() : stopRealtime()),
  { immediate: true }
)
</script>

<template>
  <Toaster position="top-right" rich-colors close-button />

  <div v-if="bare" class="min-h-screen bg-slate-50">
    <router-view />
  </div>

  <div v-else class="desk-shell flex h-screen text-slate-800">
    <AppSidebar />
    <div class="flex min-w-0 flex-1 flex-col">
      <main
        class="min-h-0 flex-1 overflow-auto"
        :class="fullPage ? 'p-0' : 'p-4 sm:p-6 lg:p-7'"
      >
        <router-view />
      </main>
    </div>
  </div>
</template>
